import React, { useState, useRef } from 'react';
import { cn } from './cn';

export interface TooltipProps {
  content: React.ReactNode;
  children: React.ReactElement<Record<string, unknown>>;
  side?: 'top' | 'right' | 'bottom' | 'left';
  delay?: number;
}

export const Tooltip: React.FC<TooltipProps> = ({ content, children, side = 'top', delay = 200 }) => {
  const [open, setOpen] = useState(false);
  const timer = useRef<number | null>(null);

  const show = () => {
    if (timer.current) window.clearTimeout(timer.current);
    timer.current = window.setTimeout(() => setOpen(true), delay);
  };
  const hide = () => {
    if (timer.current) window.clearTimeout(timer.current);
    setOpen(false);
  };

  const child = React.cloneElement(children, {
    onMouseEnter: show,
    onMouseLeave: hide,
    onFocus: show,
    onBlur: hide,
  });

  const sideClass = {
    top:    'bottom-full left-1/2 -translate-x-1/2 mb-1',
    right:  'left-full top-1/2 -translate-y-1/2 ml-1',
    bottom: 'top-full left-1/2 -translate-x-1/2 mt-1',
    left:   'right-full top-1/2 -translate-y-1/2 mr-1',
  }[side];

  return (
    <span className="relative inline-flex">
      {child}
      {open && (
        <span
          role="tooltip"
          className={cn(
            'absolute z-50 whitespace-nowrap rounded-md bg-bg-3 px-2 py-1 text-small text-text-primary shadow-2 pointer-events-none',
            sideClass
          )}
        >
          {content}
        </span>
      )}
    </span>
  );
};
